// extracted by mini-css-extract-plugin
export default {"wrapper":"wWvZUh","fitToLayout":"t2h8Xg"};